"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadFactoryFromJS = exports.LoadItemFactory = void 0;
const immutable_1 = require("immutable");
const IConfigurationItem_1 = require("../IConfigurationItem");
exports.LoadItemFactory = (0, immutable_1.Record)({
    items: (0, immutable_1.Map)()
});
const LoadFactoryFromJS = function (data) {
    if (data) {
        const items = Object.keys(data.items).reduce(function (previous, current) {
            previous[current] = (0, IConfigurationItem_1.ConfigurationItemFactoryFromJS)(data.items[current]);
            return previous;
        }, {});
        return (0, exports.LoadItemFactory)({
            items: (0, immutable_1.Map)(items)
        });
    }
    return (0, exports.LoadItemFactory)();
};
exports.LoadFactoryFromJS = LoadFactoryFromJS;
//# sourceMappingURL=ILoadPayload.js.map